import styled from 'styled-components';
import { useReportContext } from '../../../../context/DetailContext';
import { LinkSet, Renter } from '../../data';
import { formatToEokMan, ReportFormatNumber } from '../../../../func/Function';
import { useEffect, useState } from 'react';
import { useUser } from '../../../../context/UserContext';
import RegistryModal from '../registryDocument/RegistryModal';

interface Props {
  renterInfo: Renter[];
  pRenterInfo?: any;
  rentNote: string[];
  appraisalInfo: {
    appraise_date: string;
    appraiser: string;
    lessee_date: string;
  };
  linkSet?: LinkSet;
  note2?: string;
  writeDate?: string;
}

const renderMapping = {
  renter: '임차인',
  deposit: '보증금/차임(월세)',
  rpart: '전입/확정/배당',
  regDate: '대항력/기타',
};

const TenantStatus = ({
  renterInfo,
  rentNote,
  appraisalInfo,
  linkSet,
  note2,
  writeDate,
}: Props) => {
  const { user } = useUser();
  const { type, regionAccess } = useReportContext();
  const [newRentNote, setNewRentNote] = useState<string[]>([]);
  const [showAll, setShowAll] = useState<boolean>(false);
  const [openRegistryModal, setOpenRegistryModal] = useState(false);

  useEffect(() => {
    // if (rentNote.length > 0) {
    //   setNewRentNote(rentNote[0].split('<br>'));
    // } else {
    //   setNewRentNote(['-']);
    // }
  }, []);

  const handleScroll = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 120;
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  const renderData = (item: any) => {
    if (item.rpart === '조사된 임차내역없음') {
      return <EmptyItem>조사된 임차내역없음</EmptyItem>;
    } else if (
      item.renter ===
      '===== 임차인이 없으며 전부를 소유자가 점유 사용합니다. ====='
    ) {
      return (
        <EmptyItem>임차인이 없으며 전부를 소유자가 점유 사용합니다.</EmptyItem>
      );
    }
    else if (item.renter.includes('☞')) {
      // return (
      //   <TextItem>
      //     {item.renter.split('☞').map((part: any, index: number) => {
      //       return (
      //         <span key={index}>
      //           {index > 0 && '☞'}
      //           {part}
      //           <br />
      //         </span>
      //       );
      //     })}
      //   </TextItem>
      // );
    }
    else {
      return (
        <>
          <Item>
            <ItemLabel>임차인</ItemLabel>
            <ItemContent>{item.renter}</ItemContent>
          </Item>
          <Item>
            <ItemLabel>보증금/차임 (월세)</ItemLabel>
            <ItemContent>
              {item.deposit === '-' && item.monthlyRentPay === '-' ? (
                '-'
              ) : (
                <>
                  {item.deposit === '미상' ? item.deposit : item.deposit.split('\n').map((el:any) => formatToEokMan(Number(el))).join('\n')}/
                  {item.monthlyRentPay === '미상' || item.monthlyRentPay === '없음' ? item.monthlyRentPay : formatToEokMan(Number(item.monthlyRentPay))}
                </>
              )}
            </ItemContent>
          </Item>
          <Item>
            <ItemLabel>전입/확정/배당</ItemLabel>
            <ItemContent>
              {/* <ItemContentColItem isBold>
                말소기준 :
                <DateDataContent>
                  {appraisalInfo.lessee_date &&
                    (appraisalInfo.lessee_date.match(/말소기준권리 :(.*?)\//) ||
                      [])[1]}
                </DateDataContent>
              </ItemContentColItem> */}
              <ItemContentColItem>
                전입일자 : <DateDataContent>{item.regDate}</DateDataContent>
              </ItemContentColItem>
              <ItemContentColItem>
                확정일자 :{' '}
                <DateDataContent>{item.confirmedDate}</DateDataContent>
              </ItemContentColItem>
              <ItemContentColItem>
                배당요구 : <DateDataContent>{item.occupyYN}</DateDataContent>
              </ItemContentColItem>
              {/* <ItemContentColItem isBold>
                배당요구종료일 :{' '}
                <DateDataContent>
                  {appraisalInfo.lessee_date &&
                    (appraisalInfo.lessee_date.match(/배당요구종기일 :(.*)/) ||
                      [])[1]}
                </DateDataContent>
              </ItemContentColItem> */}
            </ItemContent>
          </Item>
          <Item>
            <ItemLabel>대항력</ItemLabel>
            <ItemContent
              $isRed={item.is_resistance && item.is_resistance !== '-'}
            >
              {item.is_resistance ? item.is_resistance : '-'}
            </ItemContent>
          </Item>
          <Item>
            <ItemLabel>기타</ItemLabel>
            <ItemContent>
              {/* {item.etc && item.etc !== '' && item.etc.trim().length > 1
                ? item.etc
                : '-'} */}
              -
            </ItemContent>
          </Item>
        </>
      );
    }
  };
  const link = linkSet?.buttonLink?.buildingCertificate ?? '';

  return (
    <Container id="임차인현황">
      <Title>
        <span>임차인현황</span>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
          {writeDate && <span>매각물건명세서 작성일자 : {writeDate}</span>}
          {link && (
            <PDFButton
            onClick={() => {
              const isPremium = user?.plan_grade === 'P';
              if (isPremium) window.open(link, '_blank');
              else setOpenRegistryModal(true);
            }}
          >
            <img src="/assets/images/icon/pdf.svg" alt="" />
            전입세대열람원 PDF {'>'}
          </PDFButton>
          )}
        </div>
        {/* {link && (
          <PDFButton
            onClick={() => {
              const isPremium = user?.plan_grade === 'P';
              if (isPremium) window.open(link, '_blank');
              else setOpenRegistryModal(true);
            }}
          >
            <img src="/assets/images/icon/pdf.svg" alt="" />
            전입세대열람원 PDF {'>'}
          </PDFButton>
        )} */}
      </Title>
      {type === 'a' && (
        <DataWrapper>
          <Description>
            <div>말소기준권리</div>
            <DateData>
              {(() => {
                try {
                  const dateParts = appraisalInfo.lessee_date?.split('/');
                  if (!dateParts || dateParts.length === 0) return '-';

                  const keyValue = dateParts[0].split(': ');
                  return keyValue.length > 1 ? keyValue[1] : '-';
                } catch (error) {
                  console.error('Error parsing lessee_date:', error);
                  return '-';
                }
              })()}
            </DateData>
          </Description>

          <Description>
            <div>배당요구종기일</div>
            <DateData>
              {(() => {
                try {
                  const dateParts = appraisalInfo.lessee_date?.split('/');
                  if (!dateParts || dateParts.length === 0) return '-';

                  const keyValue = dateParts[1].split(': ');
                  return keyValue.length > 1 ? keyValue[1] : '-';
                } catch (error) {
                  console.error('Error parsing lessee_date:', error);
                  return '-';
                }
              })()}
            </DateData>
          </Description>
        </DataWrapper>
      )}
      <Content>
        {renterInfo.length > 0 &&
          renterInfo
            .slice(0, showAll ? renterInfo.length : 1)
            .map((item, index) => (
              <ListDataWrapper key={index}>{renderData(item)}</ListDataWrapper>
            ))}
        {renterInfo.length > 1 && (
          <MoreButtonContainer
            onClick={() => {
              if (showAll) {
                handleScroll('임차인현황');
              }
              setShowAll((prev) => !prev);
            }}
          >
            <MoreButtonDivider />
            <MoreButton>
              <div>임차인 현황 {showAll ? '접기' : '더보기'}</div>
              <img
                style={{
                  transform: showAll ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
                src="/assets/images/arrow/Arrow_down.png"
                alt=""
              />
            </MoreButton>
            <MoreButtonDivider />
          </MoreButtonContainer>
        )}
      </Content>
      {/* {type === 'a' && newRentNote.length > 0 && newRentNote[0] !== '-' && (
        <YellowBox>
          <img src="/assets/images/icon/warning.svg" alt="" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div style={{ fontWeight: 700, fontSize: 18 }}>
              임차인 관련 주의사항
            </div>
            {newRentNote.map((item, index) => (
              <div key={index}>{item}</div>
            ))}
          </div>
        </YellowBox>
      )} */}
      {openRegistryModal && (
        <RegistryModal
          link={link}
          type={'H'}
          onClose={() => setOpenRegistryModal(false)}
        />
      )}
      {
        type === 'a' && 
          rentNote.map((item, index) => {
            return (
              <EmptyItem style={{textAlign: 'start'}}>
                <div key={index}>- {item[1]}</div>
                {item[2][0].split('\n').map((subItem, subIndex) => (
                  <div key={subIndex}>{subItem}</div>
                ))}
              </EmptyItem>
            );
          })
      }
      {
        type === 'a' && <div>
          {note2 &&
            note2 !== '-' &&
            note2
              .split('\n')
              .map((subItem, subIndex) => <EmptyItem style={{textAlign: 'start'}} key={subIndex}>{subItem}</EmptyItem>)}
        </div>
      }
    </Container>
  );
};

export default TenantStatus;

export const PTenantStatus = ({ pRenterInfo, rentNote }: any) => {
  const { type } = useReportContext();
  const [showAll, setShowAll] = useState<boolean>(false);
  const PrentNoteArray = JSON.parse(pRenterInfo);
  const filteredPrentNoteArray = PrentNoteArray.filter(
    (arr: any) => arr.length > 0,
  );

  const renderPAuctionData = (item: any) => {
    if (item.length <= 1 || item[0].includes('없습니다')) {
      return <EmptyItem>해당 내용 없음</EmptyItem>;
    } else if (item.length === 0) {
      return <EmptyItem>해당 내용 없음</EmptyItem>;
    } else {
      return (
        <>
          <Item>
            <ItemLabel>임차인</ItemLabel>
            <ItemContent>{item[1]}</ItemContent>
          </Item>
          <Item>
            <ItemLabel> 보증금/차임(월세)</ItemLabel>
            <ItemContent>
              {item[2] === '-' && item[3] === '-' ? (
                '-'
              ) : (
                <>
                  {ReportFormatNumber(Number(item[2].replace(/,/g, '')))}/
                  {ReportFormatNumber(Number(item[3]))}
                </>
              )}
            </ItemContent>
          </Item>
          <Item>
            <ItemLabel>전입/확정/배당</ItemLabel>
            <ItemContent>
              전입일자 : {item[6]} <br />
              확정일자 : {item[5]} <br />
            </ItemContent>
          </Item>
          <Item>
            <ItemLabel>대항력</ItemLabel>
            <ItemContent>
              {item.is_resistance ? item.is_resistance : '-'}
            </ItemContent>
          </Item>
          <Item>
            <ItemLabel>기타</ItemLabel>
            <ItemContent>
              {item.etc && item.etc !== '' && item.etc.trim().length > 1
                ? item.etc
                : item[0]}
            </ItemContent>
          </Item>
        </>
      );
    }
  };
  return (
    <Container id="임차인현황">
      <Title>
        <span>임차인현황</span>
        <DescriptionBox>(감정평가서 및 신고된 임대차 기준)</DescriptionBox>
      </Title>
      <Content>
        {filteredPrentNoteArray.length > 0 &&
          filteredPrentNoteArray
            .slice(0, showAll ? filteredPrentNoteArray.length : 1)
            .map((item: any, index: any) => (
              <ListDataWrapper key={index}>
                {renderPAuctionData(item)}
              </ListDataWrapper>
            ))}
        {filteredPrentNoteArray.length > 1 && (
          <MoreButton
            onClick={() => {
              setShowAll((prev) => !prev);
            }}
          >
            <div>{showAll ? '닫기' : '더보기'}</div>
            <img
              style={{
                transform: showAll ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
              alt=""
              src="/assets/images/arrow/Arrow_down.png"
            ></img>
          </MoreButton>
        )}
        {filteredPrentNoteArray.length === 0 && (
          <ListDataWrapper>{renderPAuctionData('')}</ListDataWrapper>
        )}
      </Content>
      {PrentNoteArray.length > 0 &&
        PrentNoteArray[1] &&
        !PrentNoteArray[1][0].includes('없습니다') && (
          <YellowBox>
            <img src="/assets/images/icon/warning.svg" alt="" />
            <div>
              임대차정보는 감정서상 표시내용 또는 신고된 임대차 내용으로서 누락,
              추가, 변동 될 수 있으니 참고 자료로만 활용하여야 하며, 이에 따른
              모든 책임은 입찰자에게 있습니다. 임차인의 배분요구 여부는 입찰시작
              7일전부터 제공하는 공매재산명세서를 통하여 확인하시기 바랍니다.
            </div>
          </YellowBox>
        )}
    </Container>
  );
};

const DescriptionBox = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #6b7684;
`;

interface WidthProps {
  width: string;
}

interface TableTrProps {
  isFirst?: boolean;
  isOneRow?: boolean;
}

const DataWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 8px;
  background-color: #f7f8fc;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: white;
  padding: 24px 16px;
`;

const Title = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  font-size: 16px;
  font-weight: 700;
  line-height: 145%; /* 31.9px */
  letter-spacing: -0.32px;

  & > span {
    flex: 1 0 0;
  }
`;

const DateData = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #222;
`;

const Description = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #616161;
  font-size: 12px;
  font-weight: 500;
`;
const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const TablebodyTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border: 1px solid #e8e9ea;
  padding: 6px 0;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: #171e26;
`;
const YellowBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(250, 177, 47, 0.1);
  border-radius: 8px;
  padding: 16px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: #a86c00;
`;

const ListDataWrapper = styled.div`
  border-radius: 12px;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fc;
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #001b371a;
  align-items: center;
`;

const ItemLabel = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
`;

const ItemContent = styled.div<{ $isRed?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: flex-end;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: end;
  color: ${({ $isRed }) => ($isRed ? '#F45551' : '#222')};
`;

const EmptyItem = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #616161;
  text-align: center;
`;

const TextItem = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #616161;
`;

const MoreButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  img {
    width: 16px;
    height: 16px;
  }
`;

const MoreButtonDivider = styled.div`
  flex: 1;
  height: 1px;
  background-color: #f7f7f9;
`;

const MoreButton = styled.button`
  padding: 8px 20px;
  border-radius: 9999px;
  border: none;
  background-color: #f7f7f9;
  display: flex;
  flex-direction: row;
  gap: 2px;
  justify-content: center;
  align-items: center;

  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;

  &:active {
    background-color: #0000000a;
  }
`;

const DateDataContent = styled.div`
  width: 82px;
  text-align: left;
`;

const ItemContentColItem = styled.div<{ isBold?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 2px;
  justify-content: flex-end;
  font-weight: ${({ isBold }) => (isBold ? '700' : '500')};
`;

const PDFButton = styled.div<{ $disable?: boolean }>`
  display: flex;
  padding: 5px 10px 5px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: rgba(2, 32, 71, 0.05);

  cursor: ${({ $disable }) => ($disable ? 'default' : 'pointer')};
  opacity: ${({ $disable }) => ($disable ? 0.2 : 1)};

  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  color: #000c1ecc;

  &:hover {
    background-color: ${({ $disable }) => !$disable && '#001b371a'};
  }
`;
